// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PageEndSvg from '@rsuite/icon-font/lib/direction/PageEnd';
var PageEnd = createSvgIcon({
  as: PageEndSvg,
  ariaLabel: 'page end',
  category: 'direction',
  displayName: 'PageEnd'
});
export default PageEnd;